import React from 'react';
import { t } from 'ttag';

import ProductCard from '@modules/ProductCard/ProductCard';

export default function SearchCategories({
  searchResults,
  options: { locale }
}) {
  const { products } = searchResults;

  if (!products?.length) return null;

  return (
    <section>
      <h2 className="mb-4 mt-8 text-base font-semibold uppercase text-dark-gray">{t`Products`}</h2>
      <ul
        className="m-0 flex list-none flex-wrap gap-4 p-0"
        data-testid="suggested-products"
      >
        {products?.map(product => (
          <li key={product.product_id}>
            <ProductCard
              className="w-40 bg-white p-2 sm:w-48 md:w-56"
              href={product?.relative_url || '#'}
              isExclusive={product.is_exclusive}
              productId={product.product_id}
            >
              <ProductCard.Image src={product.image} alt={product.name} />
              <ProductCard.Labels />
              <ProductCard.Ratings />
              <ProductCard.Title>{product.name}</ProductCard.Title>
              <ProductCard.Price
                isDiscounted={product?.prices?.discount_percentage || 0}
                locale={locale}
                maxPrice={product?.prices?.max_price}
                minPrice={product?.prices?.min_price}
                priceCurrency={product.prices.currency}
                recommendedRetailPrice={
                  product?.prices?.recommended_retail_price
                }
              />
            </ProductCard>
          </li>
        ))}
      </ul>
    </section>
  );
}
